<dashboard-loader *ngIf="loadingMetrics$ | async" [title]="'Loading Metrics...'"></dashboard-loader>
<div
  class="dashboard-metrics-preview"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  *ngIf="metricsLoaded$ | async"
>
  <div
    *ngIf="!metrics?.modules?.length; else metricsTable"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxFlexOffset="30px"
  >
    No responses available
  </div>
  <ng-template #metricsTable>
    <div class="dashboard-metrics-preview__table">
      <table>
        <tr>
          <th>Participant ID</th>
          <th
            *ngFor="
              let participant of participantIndex !== null && participants !== undefined
                ? participants
                : metrics?.participants
            "
          >
            {{ participant?.tag || participant?.uuid || participant.id }}
          </th>
        </tr>

        <tbody *ngFor="let module of metrics?.modules; let i = index">
          <tr
            *ngIf="i === 0"
            class="dashboard-metrics-preview__table-row dashboard-metrics-preview__table-row--highlight"
          >
            <td class="dashboard-metrics-preview__table-row-cell--small">Language</td>
            <td
              class="dashboard-metrics-preview__table-row-cell--small"
              *ngFor="
                let participant of participantIndex !== null && participants !== undefined
                  ? participants
                  : metrics?.participants
              "
            >
              {{ getResponsesLanguage(participant) | titlecase }}
            </td>
          </tr>
          <tr
            *ngIf="module?.id > 0"
            class="dashboard-metrics-preview__table-row dashboard-metrics-preview__table-row--main"
          >
            <td>
              <span [innerHtml]="getModuleName(module)"></span>
            </td>
            <td
              class="dashboard-metrics-preview__table-row-cell dashboard-metrics-preview__table-row-cell--small"
              *ngFor="
                let responseTiming of participantIndex !== null
                  ? [getModuleResponseTimings(module)[participantIndex]]
                  : getModuleResponseTimings(module);
                let index = index
              "
            >
              <div class="dashboard-metrics-preview__table-row-cell--available-iteration-section">
                <div *ngIf="showTimings && responseTiming?.availableFrom && responseTiming?.answersSentOn">
                  <p>Available: {{ changeDateFormat(responseTiming.availableFrom) | date: METRICS_TIMING_FORMAT }}</p>
                  <br />
                  <p>Received: {{ changeDateFormat(responseTiming.answersSentOn) | date: METRICS_TIMING_FORMAT }}</p>
                </div>
                <div
                  *ngIf="
                    checkIfModuleIsESM(module.id) !== '' &&
                    getIterationNumbers(module, responseTiming?.participantId).length > 0
                  "
                >
                  <label>Iteration: </label>
                  <div class="dropdown-container">
                    <button (click)="toggleDropdown(responseTiming?.participantId, module.id)" class="dropdown-button">
                      {{
                        esmSelectedIteration[getSelectedIterationKey(responseTiming?.participantId, module.id)]
                          .iterationId
                      }}
                      <span
                        class="arrow"
                        [ngClass]="{
                          open:
                            esmSelectedIteration[getSelectedIterationKey(responseTiming?.participantId, module.id)]
                              .dropDown
                        }"
                      >
                        &#9660;
                      </span>
                    </button>
                    <ul
                      *ngIf="
                        esmSelectedIteration[getSelectedIterationKey(responseTiming?.participantId, module.id)].dropDown
                      "
                      class="dropdown-menu"
                    >
                      <li
                        *ngFor="let iter of getIterationNumbers(module, responseTiming?.participantId)"
                        (click)="selectIteration(iter, module.id)"
                      >
                        {{ iter.position + 1 }}: {{ iter.iterationId }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr
            *ngFor="let moduleItem of module?.moduleItems"
            class="dashboard-metrics-preview__table-row dashboard-metrics-preview__table-row--highlight"
            (click)="setSelectedModuleItem(moduleItem)"
            [ngClass]="
              moduleItem?.id === selectedModuleItem?.id ? 'dashboard-metrics-preview__table-row--highlight-checked' : ''
            "
          >
            <td>
              <span
                *ngIf="
                  moduleItem.translations | dashboardTranslate: 'label':selectedLanguage?.code as label;
                  else questionView
                "
              >
                {{
                  (label | dashboardStripHtml | dashboardStripDynamicValues)?.length < MODULE_ITEM_QUESTION_LENGTH_LIMIT
                    ? (label | dashboardStripHtml | dashboardStripDynamicValues)
                    : (label
                        | dashboardStripHtml
                        | dashboardStripDynamicValues
                        | slice: 0:MODULE_ITEM_QUESTION_LENGTH_LIMIT) + '...'
                }}
              </span>
              <ng-template #questionView>
                <span
                  *ngIf="
                    moduleItem.translations | dashboardTranslate: 'question':selectedLanguage?.code as question;
                    else noQuestion
                  "
                >
                  {{
                    (question | dashboardStripHtml | dashboardStripDynamicValues)?.length <
                    MODULE_ITEM_QUESTION_LENGTH_LIMIT
                      ? (question | dashboardStripHtml | dashboardStripDynamicValues)
                      : (question
                          | dashboardStripHtml
                          | dashboardStripDynamicValues
                          | slice: 0:MODULE_ITEM_QUESTION_LENGTH_LIMIT) + '...'
                  }}
                </span>
              </ng-template>
              <ng-template #noQuestion>{{ 'Untitled ' + moduleItem?.subType }}</ng-template>

              <ng-container *ngIf="getChoices(moduleItem)?.length">
                <span class="dashboard-metrics-preview__table-row dashboard-metrics-preview__table-row--sub">
                  <br /><br />
                  <ng-container *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.MULTIPLE_CHOICE">
                    <div *ngFor="let choice of getChoices(moduleItem)">- {{ choice }} <br /><br /></div>
                  </ng-container>
                  <ng-container *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.LIKERT">
                    <p>- choice / numeric value</p>
                    <br />
                    <p>- other / numeric value</p>
                  </ng-container>
                </span>
              </ng-container>
            </td>
            <td
              class="dashboard-metrics-preview__table-row-cell-answer"
              *ngFor="
                let response of participantIndex !== null
                  ? [getResponseValues(module, moduleItem)[participantIndex]]
                  : getResponseValues(module, moduleItem);
                let i = index
              "
            >
              <ng-container *ngIf="getResponseType(moduleItem?.subType) as responseType">
                <span *ngIf="responseType === ANSWERS_TYPE.TEXT">
                  <span *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.IVY">
                    {{
                      getIvyMetrics(response?.response) === null || getIvyMetrics(response?.response) === undefined
                        ? '-'
                        : getIvyMetrics(response?.response)
                    }}
                  </span>
                  <span
                    *ngIf="
                      moduleItem?.subType !== ModuleItemAvailableSubType.IVY &&
                      moduleItem?.subType !== ModuleItemAvailableSubType.LIKERT &&
                      moduleItem?.subType !== ModuleItemAvailableSubType.DROPDOWN
                    "
                    [innerHTML]="response?.response || '-'"
                  ></span>

                  <ng-container
                    *ngIf="
                      moduleItem?.subType === ModuleItemAvailableSubType.DROPDOWN &&
                      response?.response !== null &&
                      response?.response !== undefined
                    "
                  >
                    {{
                      getChoices(moduleItem)?.length ? getChoices(moduleItem)[response?.response] : response?.response
                    }}
                  </ng-container>

                  <ng-container *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.LIKERT">
                    <br /><br />
                    <p
                      *ngIf="
                        !getResponseValueByType(participantIds[i], moduleItem, RESPONSES_TYPE.TEXT);
                        else otherTextResponse
                      "
                    >
                      {{ getChoices(moduleItem)[response?.response] || '-' }}
                      / {{ getResponseValueByType(participantIds[i], moduleItem, RESPONSES_TYPE.NUMBER) }}
                    </p>
                    <br />
                    <ng-template #otherTextResponse>
                      <br /><br /><br /><br /><br />
                      <p>
                        {{ getResponseValueByType(participantIds[i], moduleItem, RESPONSES_TYPE.TEXT) }}
                        / {{ getResponseValueByType(participantIds[i], moduleItem, RESPONSES_TYPE.NUMBER) }}
                      </p>
                    </ng-template>
                  </ng-container>
                </span>
                <span
                  *ngIf="responseType === ANSWERS_TYPE.ICON"
                  class="dashboard-metrics-preview__table-row-cell-answer-icon"
                >
                  <ng-container *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.YES_NO">
                    <mat-icon
                      [ngClass]="
                        response?.response
                          ? 'dashboard-metrics-preview__table-row-cell-answer-icon--correct'
                          : 'dashboard-metrics-preview__table-row-cell-answer-icon--incorrect'
                      "
                    >
                      {{ response?.response ? 'done' : 'close' }}
                    </mat-icon>
                  </ng-container>
                  <ng-container *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.YES_NO_OTHER">
                    <mat-icon
                      *ngIf="response?.response === 1; else noOtherResponse"
                      class="dashboard-metrics-preview__table-row-cell-answer-icon--correct"
                    >
                      done
                    </mat-icon>
                    <ng-template #noOtherResponse>
                      No / {{ getResponseValueByType(participantIds[i], moduleItem, RESPONSES_TYPE.TEXT) }}
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="moduleItem?.subType === ModuleItemAvailableSubType.MULTIPLE_CHOICE">
                    <span
                      class="dashboard-metrics-preview__table-row-cell-answer-icon"
                      *ngFor="let choice of getChoices(moduleItem); let i = index"
                    >
                      <br /><br />
                      <mat-icon
                        [ngClass]="
                          response?.response?.length
                            ? response?.response.includes(i)
                              ? 'dashboard-metrics-preview__table-row-cell-answer-icon--correct'
                              : 'dashboard-metrics-preview__table-row-cell-answer-icon--incorrect'
                            : ''
                        "
                        *ngIf="choice !== 'other'; else otherMultiChoice"
                      >
                        {{ response?.response?.length ? (response?.response?.includes(i) ? 'done' : 'close') : '-' }}
                      </mat-icon>
                    </span>
                    <ng-template #otherMultiChoice>
                      {{ getResponseValueByType(participantIds[i], moduleItem, RESPONSES_TYPE.TEXT) || '-' }}
                    </ng-template>
                  </ng-container>
                </span>
                <span *ngIf="responseType.includes(ANSWERS_TYPE.LINKS) && response?.response">
                  <button
                    mat-button
                    color="primary"
                    (click)="showImageResponse(response?.response, moduleItem?.subType)"
                  >
                    Show image
                  </button>
                  <ng-container *ngIf="responseType.includes(ANSWERS_TYPE.ITEMS)">
                    <button mat-button color="primary">
                      <a [href]="getImageData(response?.response)" [download]="'orbit-' + moduleItem?.id">
                        Download image
                      </a>
                    </button>
                    <br />
                    <span *ngFor="let orbitItem of getOrbitItems(response?.response)">
                      Item - {{ orbitItem?.item }} <br />
                      Length - {{ orbitItem?.length }} <br />
                      Color - {{ orbitItem?.color }}
                      <br />
                    </span>
                  </ng-container>
                </span>
                <span
                  class="dashboard-metrics-preview__table-row-cell-answer--right"
                  *ngIf="showTimings && response?.response"
                >
                  <mat-chip>{{ getResponseTiming(response, moduleItem?.id) }}</mat-chip>
                </span>
              </ng-container>
            </td>
          </tr>
          <ng-container
            *ngIf="
              selectedStudy?.healthEnabled &&
              module.id > 0 &&
              !module.enrolment &&
              (module.sleepType || module.stepsType || module.heartRateType)
            "
          >
            <tr
              class="dashboard-metrics-preview__table-row dashboard-metrics-preview__table-row--highlight dashboard-metrics-preview__table-row--last"
              *ngFor="let healthDataType of HEALTH_DATA_TYPES"
            >
              <td (click)="healthDataType.showData = !healthDataType.showData">
                {{ healthDataType.translation }}
              </td>
              <td
                *ngFor="let health of getHealths(module)"
                (click)="healthDataType.showData = !healthDataType.showData"
              >
                <ng-container
                  *ngIf="
                    healthDataType && health && (health[healthDataType.value] || health?.activity?.value);
                    else emptySensoryData
                  "
                >
                  <span
                    class="dashboard-metrics-preview__table-row-cell--small"
                    *ngIf="health[healthDataType.value].length > 0 && !healthDataType.showData"
                  >
                    (Click to view data)
                  </span>
                  <span *ngIf="health[healthDataType.value].length === 0">-</span>
                  <ng-container *ngFor="let healthData of health[healthDataType.value]">
                    <div
                      title="Click here to see graph"
                      class="dashboard-metrics-preview__table-row-cell-answer dashboard-metrics-preview__table-row-cell--small dashboard-metrics-preview__table-row--clickable"
                      *ngIf="
                        healthDataType &&
                        getHealthValue(healthDataType.value, healthData).value &&
                        healthDataType.showData
                      "
                      (click)="showHealthGraph(health, healthDataType)"
                    >
                      <span class="dashboard-metrics-preview__table-row-cell--double">
                        <span
                          *ngIf="
                            getHealthValue(healthDataType.value, healthData).value &&
                            healthDataType.value === HEALTH_DATA_VALUE.HEART_RATE
                          "
                        >
                          Date:
                          {{ getHealthValue(healthDataType.value, healthData).date | date: HEALTH_DATE_FORMAT }}
                        </span>
                        <span
                          *ngIf="
                            getHealthValue(healthDataType.value, healthData).value &&
                            healthDataType.value !== HEALTH_DATA_VALUE.HEART_RATE
                          "
                        >
                          Start Date:
                          {{ getHealthValue(healthDataType.value, healthData).startDate | date: HEALTH_DATE_FORMAT }}
                        </span>
                        <br />
                        <span
                          *ngIf="
                            getHealthValue(healthDataType.value, healthData).value &&
                            healthDataType.value !== HEALTH_DATA_VALUE.HEART_RATE
                          "
                        >
                          End Date:
                          {{ getHealthValue(healthDataType.value, healthData).endDate | date: HEALTH_DATE_FORMAT }}
                        </span>
                      </span>
                      <span class="dashboard-metrics-preview__table-row-cell-answer--right">
                        <span>{{ getHealthValue(healthDataType.value, healthData).value }}</span>
                        &nbsp;
                        <mat-chip
                          *ngIf="
                            getHealthValue(healthDataType.value, healthData).value &&
                            healthDataType.value !== HEALTH_DATA_VALUE.SLEEP
                          "
                        >
                          {{ getHealthValue(healthDataType.value, healthData).unit }}
                        </mat-chip>
                      </span>
                    </div>
                  </ng-container>
                  <ng-container *ngFor="let healthData of healthActivitiesToArray(health?.activity?.value)">
                    <div
                      class="dashboard-metrics-preview__table-row-cell-answer dashboard-metrics-preview__table-row-cell--small"
                      *ngIf="healthDataType && getHealthValue(healthDataType.value, healthData).value"
                    >
                      <span class="dashboard-metrics-preview__table-row-cell--double">
                        <span *ngIf="getHealthValue(healthDataType.value, healthData).value">
                          Start Date:
                          {{ health?.activity?.startDate | date: HEALTH_DATE_FORMAT }}
                        </span>
                        <br />
                        <span *ngIf="getHealthValue(healthDataType.value, healthData).value">
                          End Date:
                          {{ health?.activity?.startDate | date: HEALTH_DATE_FORMAT }}
                        </span>
                      </span>
                      <span class="dashboard-metrics-preview__table-row-cell-answer--right">
                        <span>{{ getHealthValue(healthDataType.value, healthData).value }}</span>
                        &nbsp;
                        <mat-chip *ngIf="getHealthValue(healthDataType.value, healthData).value">
                          {{ getHealthValue(healthDataType.value, healthData).unit }}
                        </mat-chip>
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #emptySensoryData>-</ng-template>
              </td>
            </tr>
          </ng-container>
          <ng-container
            *ngIf="
              selectedStudy?.phenotypingEnabled &&
              module.id > 0 &&
              !module.enrolment &&
              (module.batteryLifeType || module.locationType)
            "
          >
            <tr
              class="dashboard-metrics-preview__table-row dashboard-metrics-preview__table-row--highlight dashboard-metrics-preview__table-row--last"
              *ngFor="let phenotypingDataType of PHENOTYPING_DATA_TYPES"
            >
              <td>
                {{ phenotypingDataType.translation }}
              </td>
              <td *ngFor="let phenotype of getPhenotypes(module)">
                <ng-container
                  *ngIf="
                    phenotypingDataType && phenotype && phenotype[phenotypingDataType.value];
                    else emptySensoryData
                  "
                >
                  <span *ngIf="phenotype[phenotypingDataType.value].length === 0">-</span>
                  <ng-container *ngFor="let phenotypeData of phenotype[phenotypingDataType.value]">
                    <div
                      class="dashboard-metrics-preview__table-row-cell-answer dashboard-metrics-preview__table-row-cell--small dashboard-metrics-preview__table-row"
                      *ngIf="
                        phenotypingDataType &&
                        getPhenotypingValue(phenotypingDataType.value, phenotypeData).value &&
                        phenotypingDataType.showData
                      "
                    >
                      <span class="dashboard-metrics-preview__table-row-cell--double">
                        <span
                          *ngIf="
                            getPhenotypingValue(phenotypingDataType.value, phenotypeData).value &&
                            phenotypingDataType.value === PHENOTYPING_DATA_VALUE.BATTERY
                          "
                        >
                          {{ getPhenotypingValue(phenotypingDataType.value, phenotypeData).value }}
                          {{ getPhenotypingValue(phenotypingDataType.value, phenotypeData).unit }}
                        </span>
                        <span
                          *ngIf="
                            getPhenotypingValue(phenotypingDataType.value, phenotypeData).value &&
                            phenotypingDataType.value === PHENOTYPING_DATA_VALUE.LOCATION
                          "
                        >
                          {{ getPhenotypingValue(phenotypingDataType.value, phenotypeData).value }}
                        </span>
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #emptySensoryData>-</ng-template>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-template>
</div>
<div
  *ngIf="(loadingMetrics$ | async) === false && (metricsLoaded$ | async) === false && (error$ | async) as error"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <div fxLayout="column" fxLayoutAlign="start center" fxFlexOffset="30px" class="dashboard-metrics-preview-error">
    {{ error }}
  </div>
</div>

<div
  *ngIf="(loadingMetrics$ | async) === false && (metricsLoaded$ | async) === false && !(error$ | async)"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <div fxLayout="column" fxLayoutAlign="start center" fxFlexOffset="30px" class="dashboard-metrics-preview-error">
    Please select a filter to preview the data.
  </div>
</div>
